"use client";

import { Heart, Leaf, ShieldCheck } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function () {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const promises = [{
    icon: Leaf,
    stickerBg: "bg-creme",
    title: <><span className="!font-serif">Un vrai lien entre mamans</span></>,
    description: "Tu rejoins un petit groupe de mamans qui vivent la même étape que toi, pour échanger, poser tes questions et créer des liens qui peuvent continuer bien après le cercle.."
  }, {
    icon: ShieldCheck,
    stickerBg: "bg-beige",
    title: <><span className="!font-serif">Expertise et bienveillance</span></>,
    description: "Chaque semaine, tu es accompagnée par des professionnelles en périnatalité, là pour t’apporter des repères, répondre à tes questions et te soutenir avec bienveillance."
  }, {
    icon: Heart,
    stickerBg: "bg-ivory",
    title: <><span className="!font-serif">Un espace sans jugement</span></>,
    description: "Ici, pas de pression à “bien faire”. Tu peux venir comme tu es, avec tes questions, tes doutes, ta fatigue, ton bébé… et te sentir accueillie telle que tu es."
  }];
  return;
}